var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFossilFuel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3791_7558)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#2F2B24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3791_7558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4485 8.89872C16.175 8.61369 16.9785 8.58989 17.72 8.8372L21.72 10.1712C22.2108 10.3348 22.6569 10.611 23.0228 10.9768C23.3884 11.3426 23.6638 11.7889 23.8274 12.2796L25.1614 16.2796C25.3731 16.9153 25.3852 17.5985 25.2034 18.2405C25.1953 18.2851 25.1831 18.3297 25.1653 18.3733C25.1647 18.3749 25.1631 18.3766 25.1624 18.3782C25.1584 18.3904 25.1558 18.4031 25.1517 18.4153C24.9143 19.1067 24.4561 19.7012 23.8479 20.1067L19.8479 22.7737C19.3004 23.1387 18.6564 23.3333 17.9983 23.3333L17.9964 23.3323H17.9944C17.3379 23.3315 16.696 23.1379 16.1497 22.7737L12.1497 20.1067C11.4738 19.6561 10.9852 18.9739 10.7767 18.1888C10.5682 17.4037 10.6537 16.5687 11.0169 15.8421L13.6829 10.5091C14.0417 9.7912 14.6485 9.22732 15.3899 8.92021C15.4005 8.91583 15.4116 8.91275 15.4222 8.90849C15.431 8.9053 15.4396 8.90151 15.4485 8.89872ZM15.4007 10.4515C15.1834 10.6289 15.0036 10.851 14.8763 11.1058L12.2093 16.4388C11.9915 16.8746 11.9407 17.375 12.0657 17.846C12.1908 18.3171 12.4834 18.727 12.889 18.9974L16.889 21.6643C17.0654 21.782 17.2591 21.8687 17.4612 21.9251L18.6292 16.1126L15.4007 10.4515ZM18.844 21.8118C18.9352 21.7693 19.0244 21.7206 19.1087 21.6643L23.1077 18.9974L23.2405 18.9007C23.3949 18.7783 23.5293 18.6336 23.6409 18.4729L19.8274 16.9202L18.844 21.8118ZM19.7972 15.4681L23.9915 17.1761C23.9831 17.0694 23.9672 16.9632 23.9417 16.8587L23.8958 16.7015L22.5628 12.7015C22.4646 12.4069 22.2989 12.1388 22.0794 11.9192C21.8874 11.7273 21.6589 11.5763 21.4075 11.4759L21.2981 11.4358L17.2981 10.1018C17.0972 10.0349 16.8885 10.0018 16.68 10.0003L19.7972 15.4681Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3791_7558",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3791_7558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3791_7558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3791_7558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFossilFuel);
export default __webpack_public_path__ + "static/media/fossil_fuel.24dd65b4fa3df4876a15150a78848e42.svg";
export { ForwardRef as ReactComponent };